function shouldShowSkuReferenceDetails(skuReferenceDetails, type) {
    var skuReferenceDetailsTypes = ['PURCHASE', 'PAYMENT'];
    return Boolean(skuReferenceDetails && skuReferenceDetailsTypes.includes(type));
}
export default shouldShowSkuReferenceDetails;
//# sourceMappingURL=shouldShowSkuReferenceDetails.js.map